// extracted by mini-css-extract-plugin
export default {"textHighlight":"TextHighlight_textHighlight__xOC6q"};